// extracted by mini-css-extract-plugin
module.exports = {"root":"PostCommentFormFake-root-36EcM","messageBox":"PostCommentFormFake-messageBox-1EQjE","textarea":"PostCommentFormFake-textarea-1On-a typography-bodyCopy-3JspD"};